/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleLecturerResponseMetadata } from './moduleLecturerResponseMetadata';
import type { ModuleLecturerResponseCourses } from './moduleLecturerResponseCourses';
import type { ModuleLecturerResponseAuthor } from './moduleLecturerResponseAuthor';
import type { ModuleState } from './moduleState';
import type { ModuleLecturerResponseGrading } from './moduleLecturerResponseGrading';
import type { ModuleLecturerResponseGradingConfigSnapshot } from './moduleLecturerResponseGradingConfigSnapshot';
import type { ModuleLecturerResponseImageUrl } from './moduleLecturerResponseImageUrl';
import type { ModuleLecturerResponseIsDeprecated } from './moduleLecturerResponseIsDeprecated';
import type { ModuleLecturerResponseMandates } from './moduleLecturerResponseMandates';
import type { ModuleLecturerResponseUpgradeOffer } from './moduleLecturerResponseUpgradeOffer';
import type { ModuleLecturerResponseExamAttempt } from './moduleLecturerResponseExamAttempt';
import type { ModuleLecturerResponseVersionHistory } from './moduleLecturerResponseVersionHistory';
import type { ModuleStateTransition } from './moduleStateTransition';

/**
 * Extended module representation with additional fields for lecturers

This class extends the standard Module with additional information
that is only relevant for lecturers, such as detailed version history
and approval information.
 */
export interface ModuleLecturerResponse {
  id: string;
  version?: string;
  title: string;
  metadata: ModuleLecturerResponseMetadata;
  /** DEPRECATED: Do not use for navigation. List of courses this module belongs to. */
  courses?: ModuleLecturerResponseCourses;
  author?: ModuleLecturerResponseAuthor;
  state: ModuleState;
  grading?: ModuleLecturerResponseGrading;
  gradingConfigSnapshot?: ModuleLecturerResponseGradingConfigSnapshot;
  imageUrl?: ModuleLecturerResponseImageUrl;
  isDeprecated?: ModuleLecturerResponseIsDeprecated;
  mandates?: ModuleLecturerResponseMandates;
  upgradeOffer?: ModuleLecturerResponseUpgradeOffer;
  examAttempt?: ModuleLecturerResponseExamAttempt;
  isCurrent?: boolean;
  versionHistory?: ModuleLecturerResponseVersionHistory;
  stateTransitions?: ModuleStateTransition[];
}
